import * as CollectionTeamsActions from './teams.actions';

export { CollectionTeamsActions };
